import toThreadTimestampMs from '@/lib/threads/toThreadTimestampMs.js';

const sortThreadsBySidebarTimestamp = (threads = []) => {
  const getThreadPrimarySortTimestamp = (thread = {}) => {
    return toThreadTimestampMs(thread?.createdAt) || toThreadTimestampMs(thread?.updatedAt) || 0;
  };
  const getThreadSecondarySortTimestamp = (thread = {}) => {
    return toThreadTimestampMs(thread?.updatedAt) || toThreadTimestampMs(thread?.createdAt) || 0;
  };

  return [...threads].sort((left, right) => {
    const rightPrimaryTs = getThreadPrimarySortTimestamp(right);
    const leftPrimaryTs = getThreadPrimarySortTimestamp(left);

    if (rightPrimaryTs !== leftPrimaryTs) {
      return rightPrimaryTs - leftPrimaryTs;
    }

    const rightSecondaryTs = getThreadSecondarySortTimestamp(right);
    const leftSecondaryTs = getThreadSecondarySortTimestamp(left);

    if (rightSecondaryTs !== leftSecondaryTs) {
      return rightSecondaryTs - leftSecondaryTs;
    }

    return String(right?.id || '').localeCompare(String(left?.id || ''));
  });
};

export default sortThreadsBySidebarTimestamp;
